import { formatTime, formatTimeMs } from './format-time.js'

export function makeColumnDefsSteps () {
  return [
    {
      headerName: 'Module',
      field: 'module'
    },
    {
      headerName: 'Step',
      field: 'step'
    },
    {
      headerName: 'Created At',
      valueGetter: function (cellParams) {
        return cellParams.data.created_at
      },
      valueFormatter: function (cellParams) {
        return formatTimeMs(cellParams.value)
      }
    },
    {
      headerName: 'Updated At',
      valueGetter: function (cellParams) {
        return cellParams.data.updated_at
      },
      valueFormatter: function (cellParams) {
        return formatTime(cellParams.value)
      }
    },
    {
      headerName: 'Number Received',
      field: 'number_received',
      type: 'numericColumn'
    },
    {
      headerName: 'Number Updated',
      field: 'number_updated',
      type: 'numericColumn'
    },
    {
      headerName: 'Other Data',
      field: 'other_data',
      valueFormatter: function (cellParams) {
        return JSON.stringify(cellParams.value)
      }
    },
    {
      headerName: 'Memory',
      valueGetter: function (cellParams) {
        return cellParams.data.memory_stats
      },
      valueFormatter: function (cellParams) {
        return JSON.stringify(cellParams.value)
      }
    }
  ]
}
